// extracted by css-extract-rspack-plugin
export default {"header":"header--FIqvP_vS2Y1E2k5a","title":"title--om0YKCGvsgac9v_T","salary":"salary--l0ehBmQHwb5nnmhQ","cell":"cell--M8piDXCjYRwUMFnW"};